
import { fork, take, call, put, all } from 'redux-saga/effects'

import * as types from '../types'
import * as actions from '../actions'
import { getFengkongData } from '@/utils'
import { queryBtTaskDetail, receiveBtTaskReward, receiveBtTask, getWaterfallsFlowForH5, currentTime } from '@/network'
import Toast from '@/components/comToast'



export function* homeReqBase() {
    while (true) {
        const { data } = yield take(types.HOME_REQ_BASE);
        const { channelCode, taskCode, pageId} = data;
        try {
            const baseRes = yield call(getWaterfallsFlowForH5, { pageId });
            if(baseRes?.resultList) {
                yield put(actions.homeDetail({baseRes: baseRes.resultList, channelCode, taskCode}));
            }            
        } catch (e) {
            if(e?.error) {
                Toast.showMessage('活动太火爆了');
            }
        } finally {
        }

    }
}

export function* homeDetail() {
    while (true) {
        const { data } = yield take(types.HOME_DETAIL);
        const { baseRes, channelCode, taskCode } = data;
        try {
            const {detail, timer} = yield all({
                detail: call(queryBtTaskDetail, { channelCode, taskCode }),
                timer: call(currentTime, {})
              })
            //const detail = yield call(queryBtTaskDetail, { channelCode, taskCode }); 
            //detail.value.userIntercept = 2;
            //userIntercept  为2时，未命中人群，不显示详情   
            if(detail && 
                detail.success && 
                detail.value && 
                detail.value.userIntercept && 
                detail.value.userIntercept == '2'
            )    {
                Toast.showMessage('活动太火爆了');
                return ;
            }
            if (detail?.value && detail.success) {
                yield put(actions.homeHandle({detailRes: detail.value, baseRes, timer: timer.value}));
            } else {
                Toast.showMessage(detail.resultMsg);
            }
        } catch (e) {
            if(e?.error) {
                Toast.showMessage('活动太火爆了');
            }
        } finally {
        }

    }
}



export function* homeReward() {
    while (true) {
        const { data } = yield take(types.HOME_REWARD);
        const { channelCode, taskCode } = data;
        try {
            const {detail, timer} = yield all ({
                detail:call(receiveBtTaskReward, { channelCode, taskCode, deviceInfo: getFengkongData()}),
                timer: call(currentTime, {})
            })
            if (detail?.value && detail.success && detail.resultCode === '0000') {
                yield put(actions.homeHandle({detailRes: detail.value, timer: timer.value}));
                yield put(actions.alertShow(
                    {
                        title: '恭喜您领奖成功',
                        btnText: '立即收下',
                        reward: detail.value,
                    }
                ));
            } else if(detail.resultCode === 'A0025') {
                Toast.showMessage('该活动为京东PLUS会员专享');
            }else {
                Toast.showMessage(detail.resultMsg || '活动太火爆了');
            }
        } catch (e) {
            if(e?.error?.resultCode === 'A0025') {
                Toast.showMessage('该活动为京东PLUS会员专享');
            }else {
                Toast.showMessage(e.error.resultMsg || '活动太火爆了');
            }
        } finally {
            // const detail = yield call(queryBtTaskDetail, { channelCode, taskCode }); 
            // yield put(actions.alertShow(
            //     {
            //         title: '恭喜您领奖成功',
            //         btnText: '立即收下',
            //         reward: detail.value,
            //         //action: () => console.log(4443)
            //     }
            // ));
        }

    }
}

export function* homeRecTask() {
    while (true) {
        const { data } = yield take(types.HOME_REC_TASK);
        const { channelCode, taskCode } = data;
        try {
            const v = yield call(receiveBtTask, { channelCode, taskCode, deviceInfo: getFengkongData() })
            if (v?.value && v.success && v.resultCode === '0000') {
                Toast.showMessage('恭喜您成功参与活动~');
                yield put(actions.homeDetail({channelCode, taskCode}));
            } else if(v.resultCode === 'A0025') {
                Toast.showMessage('该活动为京东PLUS会员专享');
            }else {
                Toast.showMessage(v.resultMsg || '活动太火爆了');
            }
        } catch (e) {
            if(e?.error?.resultCode === 'A0025') {
                Toast.showMessage('该活动为京东PLUS会员专享');
            }else {
                Toast.showMessage(e.error.resultMsg || '活动太火爆了');
            }
        } finally {
        }

    }
}
export default function* root() {
    yield fork(homeReqBase)
    yield fork(homeDetail)
    yield fork(homeReward)
    yield fork(homeRecTask)
}